/**
 * Check if the sortBy is paginated
 * @param {string} sortBy - The sortBy value to check
 * @returns {boolean} - True if the sortBy is paginated, false otherwise
 */
export function isPaginatedSortBy(sortBy) {
  return !(sortBy === 'BEST_SELLING' || sortBy === 'RECOMMENDATIONS');
}

export const sortIdToTrackingValue = {
  DEFAULT: 'Default',
  PRICE_ASC: 'Low To High',
  PRICE_DESC: 'High To Low',
  BEST_SELLING: 'Best Selling',
  RECOMMENDATIONS: 'Recommended',
};
